import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const TransitionCurveUpIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-transition-curve-up', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.56308 13C3.04109 13 2.68485 12.9472 2.6436 12.9406C2.23411 12.8763 1.94911 12.4582 2.00761 12.007C2.06611 11.5567 2.4531 11.2475 2.85435 11.3068C2.8836 11.3118 5.13655 11.6376 6.39278 10.4335C6.96952 9.88007 7.25001 9.08421 7.25001 8.00053C7.25001 6.4286 7.71426 5.18987 8.62849 4.31731C10.4082 2.62003 13.2349 3.04064 13.3564 3.05961C13.7659 3.12394 14.0509 3.54207 13.9924 3.9932C13.9339 4.44432 13.5559 4.76184 13.1434 4.69339C13.1224 4.68844 10.8642 4.36185 9.60797 5.56677C9.03048 6.12016 8.74999 6.91602 8.74999 8.00053C8.74999 9.57163 8.28574 10.8104 7.37151 11.6829C6.19853 12.8012 4.57106 13 3.56308 13Z'
      />
    </svg>
  );
};

export default TransitionCurveUpIcon;
